import React, { FC } from "react"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import { StatBlockItemFragmentFragment } from "@graphqlTypes"

import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"

import "./StatBlockItem.scss"

const StatBlockItem: FC<StatBlockItemFragmentFragment> = ({
  icon,
  number,
  unit,
  description,
  stat,
}) => (
  <div className="StatBlockItem flex-item--1 flex-item--2-S flex-item--4-M">
    <div className="stat-with-icon">
      <div className="number-wrapper">
        {stat ? (
          <span className="number">{stat}</span>
        ) : (
          <>
            <span className="number">{number && number.toLocaleString()}</span>
            {unit && <span className={`unit${unit === "%" ? " is-percent" : ""}`}>{unit}</span>}
          </>
        )}

      </div>
      <div className="icon-wrapper">
        <Icon
          color="var(--StatBlock--statIcon)"
          size="var(--spacing--base-1-5)"
          type={ICON_TYPES[icon as ICON_TYPES || ICON_TYPES["arrow-up"]]}
        />
      </div>
    </div >
    <div className="description type--text-S">
      {description && typeof description.raw === "string" && renderRichText({ raw: description.raw, references: [] })}
    </div>
  </div>
)

export default StatBlockItem
